import React from "react";
import { ButtonBase, Step, StepLabel, Stepper } from "@mui/material";
import RevaText from "components/common/RevaText";

export default function SchedulingStepNavigation({ activeStep, onStepChange, steps }) {
  return (
    <Stepper activeStep={activeStep} nonLinear sx={{ my: 2, overflowX: "auto", width: "100%" }}>
      {steps.map((step, index) => {
        return (
          <Step key={step.label} completed={index < activeStep} sx={{ borderRadius: 2 }}>
            <ButtonBase
              onClick={() => onStepChange(index)}
              aria-label={step.label}
              aria-current={activeStep === index ? "step" : undefined}
              sx={{
                width: "100%",
                border: "2px solid",
                borderColor: activeStep === index ? "primary.main" : "transparent",
                borderRadius: 2,
                p: 2,
                textAlign: "left",
              }}
            >
              <StepLabel
                slotProps={{ stepIcon: { sx: { width: 32, height: 32, mr: 1 } } }}
                optional={<RevaText variant="body2">{step.description}</RevaText>}
              >
                <RevaText variant="subtitle1">{step.label}</RevaText>
              </StepLabel>
            </ButtonBase>
          </Step>
        );
      })}
    </Stepper>
  );
}
